import { FC, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { tokens } from '@JOTAJornalismo/jota-design-system'
import { FormRDI } from '@App/libs/interfaces/PRO.interfaces'
import { RD_ID } from '@App/libs/utils/constants/pro'
import { addDatalayer } from '@App/libs/utils/geral'
import { StoreType } from '@App/api/types/store'
import { useSelector } from 'react-redux'
import { validateFields, getEventByType } from '@App/libs/utils/pro'

const { spaces } = tokens

export const FormRDComponent: FC<FormRDI> = ({ url, type }) => {
    const divForm = useRef(null)
    const { auth } = useSelector((state: StoreType) => state)
    const userBO: any = auth.user?.getUserBO()

    useEffect(() => {
        const divTemp = divForm.current

        if (!divTemp) return

        const startObserver = () => {
            if (typeof window.RDStationForms === 'undefined') return
            new window.RDStationForms(url, RD_ID).createForm()
            const formRD = document.getElementById(url)

            if (!formRD) return
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    startObserver()
                }
            })
        })

        const formObserver = new MutationObserver(() => {
            const form = document.getElementsByTagName('form')

            const name = (
                document.getElementsByName('name')[0] as HTMLInputElement
            ).value
            const email = (
                document.getElementsByName('email')[0] as HTMLInputElement
            ).value
            const companyEmployees = (
                document.getElementsByClassName(
                    'js-field-cf_numeros_de_funcionario_da_empresa'
                )[0] as HTMLInputElement
            ).value
            const jobTitle = (
                document.getElementsByName('job_title')[0] as HTMLInputElement
            ).value
            const personalPhone = (
                document.getElementsByName(
                    'personal_phone'
                )[0] as HTMLInputElement
            ).value

            if (
                !name ||
                !email ||
                !jobTitle ||
                !validateFields(email, companyEmployees, personalPhone)
            ) {
                return
            }

            if (form.length && form[0].checkValidity()) {
                const dataTemp = {
                    url: window.location.href,
                    vertical: type.toLowerCase(),
                    history_page: document.referrer,
                    date: new Date().getTime(),
                    title: document.title,
                    user_company: userBO?.profile?.company_name,
                    user_tier: userBO?.profile?.company_tier,
                    user_company_other: userBO?.profile?.company_type_other,
                    user_plan: userBO?.profile?.plan,
                    user_vertical: userBO?.verticals,
                    type: 'JU'
                }

                addDatalayer({
                    event: getEventByType(type),
                    ...dataTemp
                })
            }
        })

        const config = { childList: true, subtree: true }
        formObserver.observe(divTemp, config)

        if (divTemp) {
            observer.observe(divTemp)
        }

        return () => {
            if (divTemp) {
                observer.unobserve(divTemp)
            }
        }
    }, [url])

    return <FormContent id={url} ref={divForm} />
}

const FormContent = styled.div`
    margin: ${spaces.jotaSpacing16} 0;
`
